import variantsService from '../../services/variantsService'

class VariantsController {
  fetchVariants = variantsService.fetchVariants
}

export default new VariantsController()
 


// WEBPACK FOOTER //
// ../src/controllers/variantsController/variantsController.js